/**
 * A diagram the course names but nobody has drawn yet: the picture's title, set as a picture, so the lesson page keeps
 * its shape and the test that every name has a drawing still means something. Replaced one file at a time as the
 * industry track's pictures are drawn; nothing here is a Lantern diagram.
 */
import type React from 'react';
import { useTheme } from '@mui/material/styles';
import { color, diagramStyle } from './palette';

export function undrawn(title: string): React.FC {
  const Undrawn: React.FC = () => {
    const theme = useTheme();
    return (
      <svg viewBox="0 0 940 220" xmlns="http://www.w3.org/2000/svg" role="img" aria-label={title} style={diagramStyle(theme)}>
        <rect x="20" y="30" width="900" height="160" rx="12" fill="none" stroke={color.muted} strokeWidth="2" />
        <text x="470" y="105" textAnchor="middle" fontSize="20" fontWeight="600" fill={color.fg}>
          {title}
        </text>
        <text x="470" y="140" textAnchor="middle" fontSize="14" fill={color.muted}>
          picture to be drawn
        </text>
      </svg>
    );
  };
  Undrawn.displayName = `Undrawn(${title})`;
  return Undrawn;
}
